import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sender-name message-color" }
const _hoisted_2 = { key: 1 }

import {computed} from 'vue';
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import Dictionary from "~/ts/library/Dictionary";
import {__} from "~/ts/library/Translate";
import {MyTooltipOptionInterface} from "~/core-ui/vue/ui/my-tooltip/MyTooltipOptionInterface";
import {useRawComponent} from "~/core-ui/ts/useRawComponent";
import CoreUiChatHistoryMessageTitleTooltip from "~/core-ui/vue/chat/CoreUiChatHistoryMessageTitleTooltip.vue";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";


const __default__ = {
    name: "CoreUiChatHistoryMessageTitle"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    operator: {},
    operatorsDictionary: {},
    client: {},
    you: {},
    showOperatorLogins: { type: Boolean, default: true },
    showReceiver: { type: Boolean, default: true },
    showOperatorGroup: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;

let isMessageForYou = computed(() => {
    return props.operator && props.you && props.operator.id === props.you.id;
});

let isShowReceiver = computed(() => {
    return props.showReceiver && !isMessageForYou.value || (props.showOperatorGroup && !!props.message.operatorGroup);
})

function getOperatorByLogin(login: string): OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel | null {
    return props.operatorsDictionary[login];
}

let tooltip = computed<MyTooltipOptionInterface>(() => {
    if (props.message.isSendByClient || props.message.recipients) {
        if (props.message.operatorGroup || props.message.recipients?.length > 0) {
            return {
                component: useRawComponent(CoreUiChatHistoryMessageTitleTooltip),
                props: {
                    message: props.message,
                    showOperatorLogins: props.showOperatorLogins,
                    getOperatorByLogin
                },
                delay: 500
            }
        }
    }
    return null;
})

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "before"),
    (__props.message.isSendByClient && !_unref(CoreUiChatHistoryHelper).isOneOfCrossOperatorsChatMessage(__props.message))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.message.senderOverride?.name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(__props.message.senderOverride?.name), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(__props.client ? __props.client.fields.descr : 'Посетитель'), 1)
              ], 64)),
          (_unref(isShowReceiver))
            ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                key: 2,
                icon: "arrow-right",
                light: ""
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (!__props.message.isSendByClient || _unref(isShowReceiver))
      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_2, [
          (_unref(isMessageForYou))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(__)("Вы")), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!__props.message.isSendByClient && __props.message.senderOverride?.name)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(__props.message.senderOverride?.name), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (__props.operator)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(__props.operator.fio) + " ", 1),
                            (__props.operator.fio !== __props.operator.login && __props.showOperatorLogins)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" (" + _toDisplayString(__props.operator.login) + ") ", 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(__props.message.operatorLogin), 1)
                          ], 64))
                    ], 64))
              ], 64)),
          (__props.showOperatorGroup && __props.message.operatorGroup)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(" (" + _toDisplayString(__props.message.operatorGroup.descr) + ") ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ])), [
          [_directive_my_tooltip, _unref(tooltip)]
        ])
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "after")
  ]))
}
}

})